module.exports = __webpack_public_path__ + "officialStatic/img/detail-night-bg.320d13d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/solution/detail-night-bg.png
// module id = zSxh
// module chunks = 0